import React, { useImperativeHandle, useRef, useState } from "react";
import { RCCGrid, RCCModal, RCCRefModalProps } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { css } from "styled-components";
import { IDescriptionModal, IRefDescriptionModal } from "./interface";

const ModalDescription: React.ForwardRefRenderFunction<IRefDescriptionModal, IDescriptionModal> = ({
	height = "200px",
	children, 
	...rest
}, ref) => {


	const modalRef = useRef<RCCRefModalProps>(null);

	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [heightModal, setHeightModal] = useState(height);

	const openModal = (titleX: string, descriptionX: string, heightX?: string) => {
		setTitle(titleX ?? "");
		setDescription(descriptionX ?? "");
		setHeightModal(heightX ?? height);
		modalRef.current?.openModal();
	};


	useImperativeHandle(ref, () => ({
		openModal
	}));
  
	const { translate } = useTranslation();
	return (
		<RCCModal
			ref={modalRef}
			header={{
				title,
				icon: {
					name: "infoCircle",
					size: 26
				}
			}}
			footer={{
				cancelButtonText:translate("Sair"),
				showSaveButton:false
			}}
			styleInline={css`
					width: 50vw;
					min-width: 300px;
					height: ${heightModal};
					position: absolute;
					top: 60px;
			`}
			{...rest}
		>
			<RCCGrid
				container
				item
				justifyContent="center"
				direction="column"
			>
				<h4>
					{description}
				</h4>
			</RCCGrid>
			{children}
		</RCCModal>
	);
};

export default React.forwardRef(ModalDescription);
